import AutoSubmit from './AutoSubmit';

export default AutoSubmit;
